import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreMission from '../components/ExploreMission';
import ExploreSuccess from '../components/ExploreSuccess';

export default function ExploreLinkPage() {
  return (
    <ExploreLayout
      stepId="link"
      eyebrow="Link Experience"
      title="Save the delivery rush."
      subtitle="This placeholder prepares the Link mission path where visitors watch stock, staff, drivers and ETA connect before assignment."
      nextLabel="Build my company"
    >
      <div className="explore-split">
        <ExploreMission
          title="Mission: Choose the best fulfilment path"
          description="The closest store is not always the fastest store. Link evaluates capacity before the order is assigned."
          tasks={[
            'Review the customer address',
            'Compare store stock and workload',
            'Choose the best driver',
            'Watch ETA improve',
          ]}
        />
        <div className="explore-console">
          <div className="explore-console-header">
            <span>Link Coordination</span>
            <strong>Rush Hour</strong>
          </div>
          <div className="explore-console-screen">
            <div className="explore-console-row"><span>Closest Site</span><strong>Parow · 3h ETA</strong></div>
            <div className="explore-console-row"><span>Recommended Site</span><strong>Bothasig · 52m ETA</strong></div>
            <div className="explore-console-row"><span>Drivers Available</span><strong>6</strong></div>
            <div className="explore-console-row"><span>Decision Time</span><strong>&lt; 1 min</strong></div>
          </div>
        </div>
      </div>
      <ExploreSuccess title="Link path ready" description="Future sprints can turn this into the interactive dispatch simulator." />
    </ExploreLayout>
  );
}
